import React from 'react';
import _ from 'lodash';
import { Box, ButtonBase, Dialog, makeStyles } from '@material-ui/core';
import Text from '../../../components/Text';
import { DropRightIcon } from '../../../components/Icon';
import Card from './Card';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiDialog-paper': {
      margin: 'unset',
      maxWidth: 'unset',
      maxHeight: 'unset',
      width: '100vw',
      height: '100vh',
      backgroundColor: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem 1.87rem 0',
      gap: '1.25rem',
    },
  },
  rowContainer: {
    display: 'flex',
    gridGap: '1.25rem',
    width: '100%',
    flex: 1,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFF',
    borderRadius: '1rem',
    flex: 1,
    flexBasis: '50%',
  },
  headerContainer: {
    backgroundColor: '#E4E7EB',
    borderRadius: '1rem 1rem 0rem 0rem',
    height: '2.625rem',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '1.25rem',
  },
  dropRightIcon: {
    fontSize: '1rem',
    color: '#2e4469',
  },
  listContainer: {
    display: 'grid',
    gridTemplateRows: 'repeat(auto-fill, 3.75rem)',
    flex: 1,
    padding: '0 1.25rem',
  },
}));

const rowItemCount = 5;

const ViewOther = ({ allData, handleClose }) => {
  const classes = useStyles();
  return (
    <Dialog className={classes.root} open={true}>
      <Box className={classes.rowContainer}>
        <Box className={classes.container}>
          <Box className={classes.headerContainer}>Reprocessing ({allData?.Reprocessing?.qty})</Box>
          <Box flex={1} overflow="auto">
            <Box className={classes.listContainer} gridTemplateColumns="auto 1fr auto 1fr">
              {allData?.Reprocessing?.wards.map((item) => (
                <React.Fragment key={item?.id}>
                  <Box
                    display="flex"
                    alignItems="flex-start"
                    gridGap="0.5rem"
                    borderBottom="1px solid #EEEEEE"
                    style={{ gridRowStart: `span ${Math.ceil(item.assets / rowItemCount)}` }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      gridGap="0.5rem"
                      pr="1rem"
                      borderBottom="1px solid #EEEEEE"
                      height="3.75rem"
                      flex={1}
                    >
                      <Text fontSize="1.375rem" fontWeight="700" color="#2E4469">
                        {item?.name ?? '--'}
                      </Text>
                    </Box>
                  </Box>
                  <Box
                    borderBottom="1px solid #EEEEEE"
                    style={{ gridRowStart: `span ${Math.ceil(item.assets / rowItemCount)}` }}
                  >
                    {_.chunk(item.assets, rowItemCount).map((rowItem, rowIndex) => (
                      <Box
                        height="3.75rem"
                        display="flex"
                        alignItems="center"
                        borderBottom="1px solid #EEEEEE"
                        gridGap="0.25rem"
                        key={rowIndex}
                      >
                        {rowItem.map((assetItem) => (
                          <Card name={assetItem.refNo ?? '--'} color={assetItem.color} key={assetItem.assetId} />
                        ))}
                      </Box>
                    ))}
                  </Box>
                </React.Fragment>
              ))}
            </Box>
          </Box>
        </Box>
        <Box className={classes.container}>
          <Box className={classes.headerContainer}>Not for loan ({allData?.['Not for loan']?.qty})</Box>
          <Box flex={1} overflow="auto">
            <Box className={classes.listContainer} gridTemplateColumns="auto 1fr auto 1fr">
              {allData?.['Not for loan']?.wards.map((item) => (
                <React.Fragment key={item?.id}>
                  <Box
                    display="flex"
                    alignItems="flex-start"
                    gridGap="0.5rem"
                    borderBottom="1px solid #EEEEEE"
                    style={{ gridRowStart: `span ${Math.ceil(item.assets / rowItemCount)}` }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      gridGap="0.5rem"
                      pr="1rem"
                      borderBottom="1px solid #EEEEEE"
                      height="3.75rem"
                      flex={1}
                    >
                      <Text fontSize="1.375rem" fontWeight="700" color="#2E4469">
                        {item?.name ?? '--'}
                      </Text>
                    </Box>
                  </Box>
                  <Box
                    borderBottom="1px solid #EEEEEE"
                    style={{ gridRowStart: `span ${Math.ceil(item.assets / rowItemCount)}` }}
                  >
                    {_.chunk(item.assets, rowItemCount).map((rowItem, rowIndex) => (
                      <Box
                        height="3.75rem"
                        display="flex"
                        alignItems="center"
                        borderBottom="1px solid #EEEEEE"
                        gridGap="0.25rem"
                        key={rowIndex}
                      >
                        {rowItem.map((assetItem) => (
                          <Card name={assetItem.refNo ?? '--'} color={assetItem.color} key={assetItem.assetId} />
                        ))}
                      </Box>
                    ))}
                  </Box>
                </React.Fragment>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.rowContainer}>
        <Box className={classes.container}>
          <Box className={classes.headerContainer}>Reserved ({allData?.Reserved?.qty})</Box>
          <Box flex={1} overflow="auto">
            <Box className={classes.listContainer} gridTemplateColumns="auto 1fr">
              {allData?.Reserved?.wards.map((item) => (
                <React.Fragment key={item?.id}>
                  <Box
                    display="flex"
                    alignItems="flex-start"
                    gridGap="0.5rem"
                    borderBottom="1px solid #EEEEEE"
                    style={{ gridRowStart: `span ${Math.ceil(item.assets / rowItemCount)}` }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      gridGap="0.5rem"
                      pr="1rem"
                      borderBottom="1px solid #EEEEEE"
                      height="3.75rem"
                      flex={1}
                    >
                      <Text fontSize="1.375rem" fontWeight="700" color="#2E4469">
                        {item?.name ?? '--'}
                      </Text>
                    </Box>
                  </Box>
                  <Box
                    borderBottom="1px solid #EEEEEE"
                    style={{ gridRowStart: `span ${Math.ceil(item.assets / rowItemCount)}` }}
                  >
                    {_.chunk(item.assets, rowItemCount).map((rowItem, rowIndex) => (
                      <Box
                        height="3.75rem"
                        display="flex"
                        alignItems="center"
                        borderBottom="1px solid #EEEEEE"
                        gridGap="0.25rem"
                        key={rowIndex}
                      >
                        {rowItem.map((assetItem) => (
                          <Card name={assetItem.refNo ?? '--'} color={assetItem.color} key={assetItem.assetId} />
                        ))}
                      </Box>
                    ))}
                  </Box>
                </React.Fragment>
              ))}
            </Box>
          </Box>
        </Box>
        <Box className={classes.container}>
          <Box className={classes.headerContainer}>Condemned ({allData?.Condemned?.qty})</Box>
          <Box flex={1} overflow="auto">
            <Box className={classes.listContainer} gridTemplateColumns="auto 1fr">
              {allData?.Condemned?.wards.map((item) => (
                <React.Fragment key={item?.id}>
                  <Box
                    display="flex"
                    alignItems="flex-start"
                    gridGap="0.5rem"
                    borderBottom="1px solid #EEEEEE"
                    style={{ gridRowStart: `span ${Math.ceil(item.assets / rowItemCount)}` }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      gridGap="0.5rem"
                      pr="1rem"
                      borderBottom="1px solid #EEEEEE"
                      height="3.75rem"
                      flex={1}
                    >
                      <Text fontSize="1.375rem" fontWeight="700" color="#2E4469">
                        {item?.name ?? '--'}
                      </Text>
                    </Box>
                  </Box>
                  <Box
                    borderBottom="1px solid #EEEEEE"
                    style={{ gridRowStart: `span ${Math.ceil(item.assets / rowItemCount)}` }}
                  >
                    {_.chunk(item.assets, rowItemCount).map((rowItem, rowIndex) => (
                      <Box
                        height="3.75rem"
                        display="flex"
                        alignItems="center"
                        borderBottom="1px solid #EEEEEE"
                        gridGap="0.25rem"
                        key={rowIndex}
                      >
                        {rowItem.map((assetItem) => (
                          <Card name={assetItem.refNo ?? '--'} color={assetItem.color} key={assetItem.assetId} />
                        ))}
                      </Box>
                    ))}
                  </Box>
                </React.Fragment>
              ))}
            </Box>
          </Box>
        </Box>
        <Box className={classes.container}>
          <Box className={classes.headerContainer}>Repairing ({allData?.Repairing?.qty})</Box>
          <Box flex={1} overflow="auto">
            <Box className={classes.listContainer} gridTemplateColumns="auto 1fr">
              {allData?.Repairing?.wards.map((item) => (
                <React.Fragment key={item?.id}>
                  <Box
                    display="flex"
                    alignItems="flex-start"
                    gridGap="0.5rem"
                    borderBottom="1px solid #EEEEEE"
                    style={{ gridRowStart: `span ${Math.ceil(item.assets / rowItemCount)}` }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      gridGap="0.5rem"
                      pr="1rem"
                      borderBottom="1px solid #EEEEEE"
                      height="3.75rem"
                      flex={1}
                    >
                      <Text fontSize="1.375rem" fontWeight="700" color="#2E4469">
                        {item?.name ?? '--'}
                      </Text>
                    </Box>
                  </Box>
                  <Box
                    borderBottom="1px solid #EEEEEE"
                    style={{ gridRowStart: `span ${Math.ceil(item.assets / rowItemCount)}` }}
                  >
                    {_.chunk(item.assets, rowItemCount).map((rowItem, rowIndex) => (
                      <Box
                        height="3.75rem"
                        display="flex"
                        alignItems="center"
                        borderBottom="1px solid #EEEEEE"
                        gridGap="0.25rem"
                        key={rowIndex}
                      >
                        {rowItem.map((assetItem) => (
                          <Card name={assetItem.refNo ?? '--'} color={assetItem.color} key={assetItem.assetId} />
                        ))}
                      </Box>
                    ))}
                  </Box>
                </React.Fragment>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box display="flex" justifyContent="flex-end" gridGap="1.25rem" width="100%">
        <ButtonBase onClick={handleClose}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            borderRadius="1.5rem 1.5rem 0rem 0rem"
            bgcolor="#E4E7EB"
            width="27.5rem"
            p="1.56rem"
          >
            <Text fontSize="1rem" color="#2E4469" fontWeight="700">
            Return to Dashboard
            </Text>
            <DropRightIcon className={classes.dropRightIcon} />
          </Box>
        </ButtonBase>
      </Box>
    </Dialog>
  );
};

export default ViewOther;
